// グローバルに使いたいモジュール,関数はこちらで定義
// 残りはcomponents配下に配置してバンドルする方向性

$(window).on('load', function () {
  $("#Nav").css({
    top: $("#Header").outerHeight()
  }).data('height', $(window).height() - $("#Header").outerHeight());

  $(document).on("click", "#NavOpen", function () {
    $(this).toggleClass("Active");
    $("#Nav").toggleClass(function () {
      if ($(this).is(".Active")) {
        $(this).css({
          height: 0
        })
        return "Active";
      } else {
        $(this).css({
          height: $(window).height() - $("#Header").outerHeight()
        })
        return "Active";
      }
    });
  })
});
